import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import './Navbar.css';

export default function Navbar(){
  const [logoOk, setLogoOk] = useState(true);
  return (
    <nav className="navbar navbar-expand-lg navbar-light navbar-custom fixed-top">
      <div className="container">
        <Link className="navbar-brand d-flex align-items-center" to="/">
          {logoOk ? (
            <img src="/images/logo.png" alt="SocialManiacs" className="navbar-logo me-2" onError={()=>setLogoOk(false)} />
          ) : (
            <div className="me-2 rounded-3 p-2 gradient-bg text-white fw-bold">SM</div>
          )}
         
        </Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#nav">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="nav">
          <ul className="navbar-nav ms-auto mb-2 mb-lg-0 align-items-center">
            <li className="nav-item"><NavLink className="nav-link" to="/">Home</NavLink></li>
            <li className="nav-item"><NavLink className="nav-link" to="/about">About</NavLink></li>
            <li className="nav-item"><NavLink className="nav-link" to="/services">Services</NavLink></li>
            <li className="nav-item"><NavLink className="nav-link" to="/portfolio">Portfolio</NavLink></li>
            <li className="nav-item ms-2"><Link to="/contact"><button className="btn btn-primary-custom">Contact</button></Link></li>
          </ul>
        </div>
      </div>
    </nav>
  );
}


